// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3u-R2","bigColWidth":"Table_bigColWidth__1U1O4","biggerColWidth":"Table_biggerColWidth__1TrTy","row":"Table_row__1rLIm","col":"Table_col__2eL7c"};